<div class="container-scroller">
  <app-nav *ngIf="isloggedIn"></app-nav>
    <div class="container-fluid page-body-wrapper">
        <div class="main-panel">
            <div *ngIf="showLoading"  class="loader"></div>
            <router-outlet></router-outlet>
            <app-footer></app-footer>
            <!-- partial -->
        </div>
        <!-- main-panel ends -->
    </div>
        <!-- page-body-wrapper ends -->
  </div>
 